import {gsap} from "gsap";
import {BrickSnake2000} from "../BrickSnake2000";
import {BrickSnake2000GameAssets} from "../BrickSnake2000GameAssets";
import {BasedCountUp} from "./BasedCountUp";

export class FreespinsOutroInformation extends PIXI.Container {
    private totalWinStyle:PIXI.TextStyle;
    private freespinsTotalWin:PIXI.Text;
    private basedCountUp:BasedCountUp;
    private spinsPlayedStyle:PIXI.TextStyle;
    private freespinsSpinsPlayed:PIXI.Text;
    private totalMultiplierStyle:PIXI.TextStyle;
    private freespinsActualMultiplier:PIXI.BitmapText;

    constructor() {
        super();
        // freespins outro
        this.totalWinStyle = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAngle: 1.5,
            dropShadowColor: "#000000",
            dropShadowDistance: 6,
            fill: "#ffffff",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: "#000000",
            strokeThickness: 8
        });
        this.freespinsTotalWin = new PIXI.Text(BrickSnake2000.apiPlugin.translations.translate("YOU WON"), this.totalWinStyle);
        this.freespinsTotalWin.anchor.set(0.5,0.5);
        this.freespinsTotalWin.position.set(360,120);
        this.freespinsTotalWin.visible = false;

        this.basedCountUp = new BasedCountUp();
        this.basedCountUp.position.set(360,200);

        this.spinsPlayedStyle = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 1.5,
            dropShadowDistance: 6,
            fill: "#ffffff",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: "#232323",
            strokeThickness: 8
        });
        this.freespinsSpinsPlayed = new PIXI.Text(BrickSnake2000.apiPlugin.translations.translate("Spins played: 69"), this.spinsPlayedStyle);
        this.freespinsSpinsPlayed.anchor.set(0.5,0.5);
        this.freespinsSpinsPlayed.position.set(360,360);
        this.freespinsSpinsPlayed.visible = false;

        this.totalMultiplierStyle = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 1.5,
            dropShadowDistance: 6,
            fill: "#fffc00",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 8
        });

        this.freespinsActualMultiplier = new PIXI.BitmapText("x1", {
            fontName : BrickSnake2000GameAssets.BITMAP_FONT_FS_MULTI_LARGE,
            fontSize : 60,
        });
        this.freespinsActualMultiplier.position.set(360, 465);
        (<PIXI.Point>this.freespinsActualMultiplier.anchor).set(0.5, 0.5);
        this.freespinsActualMultiplier.visible = false;

        this.addChild(this.freespinsTotalWin);
        this.addChild(this.basedCountUp);
        this.addChild(this.freespinsSpinsPlayed);
        this.addChild(this.freespinsActualMultiplier);
    }

    public showOutroInformation():gsap.core.Timeline {
        //const betSize = BrickSnake2000.model.gameData.playedBetValue;
        const timesBetWon = BrickSnake2000.model.fsWinRatio;
        const totalWin = BrickSnake2000.model.gameData.accumulatedRoundWin;
        const winAboveBet = !BrickSnake2000.isWinBelowStake();
        //const subBigWinWin = timesBetWon > 15 ? betSize * 15 : totalWin;
        const tl = gsap.timeline()
        tl.add(() =>  {
            this.freespinsTotalWin.visible = (winAboveBet && !BrickSnake2000.wonNothing());
            if (winAboveBet) {
                BrickSnake2000.soundPlayer.playSound("fsOutroPresentation");
            }
        })
        tl.add(this.basedCountUp.countUpInstant(winAboveBet ? 0 : totalWin, 0), '>0.2')
        tl.add(() =>  {
            if (winAboveBet) {
                BrickSnake2000.soundPlayer.playSound("fsOutroPresentation");
            }
        }, '<')
        tl.add(() =>  {
            this.freespinsSpinsPlayed.scale.set(1,1);
            const spinPlayed: number = BrickSnake2000.model.gameData.freespinsPlayed;
            this.freespinsSpinsPlayed.text =
                BrickSnake2000.apiPlugin.translations.translate("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
            if (this.freespinsSpinsPlayed.width > 700) {
                const newScale = 700 / this.freespinsSpinsPlayed.width;
                this.freespinsSpinsPlayed.scale.set(newScale, newScale);
            }
            //Translation.translation("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
            this.freespinsSpinsPlayed.visible = true;
            if (winAboveBet) {
                BrickSnake2000.soundPlayer.playSound("fsOutroPresentation");
            }
        }, '>0.2')
        // maybe rethink this, if statements arent that bad :woozy:
        if (totalWin > 0 && winAboveBet) {
            //tl.add(() => { BrickSnake2000.soundPlayer.playSound("fsOutroCountUp")});
            //tl.add(this.basedCountUp.countUpNoFade(subBigWinWin, 0, 1.5), '<');
            //tl.add(() => {
            //    BrickSnake2000.soundPlayer.playSound("fsOutroCountUpEnd");
            //    BrickSnake2000.soundPlayer.stopSound("fsOutroCountUp");
            //})
            const randomOffset = Math.floor(10 * (Math.random() * 2 - 1));
            const thresholdNumber = timesBetWon + randomOffset;
            const growthSize =    thresholdNumber > 250
                               ? 2
                               : thresholdNumber > 100
                               ? 1.7
                               : thresholdNumber > 50
                               ? 1.4
                               : thresholdNumber > 25
                               ? 1.2
                               : 1.1
            const shakeIntensity =  thresholdNumber > 250
                                   ? 25
                                   : thresholdNumber > 100
                                   ? 16
                                   : thresholdNumber > 50
                                   ? 9
                                   : thresholdNumber > 25
                                   ? 4
                                   : 2
            const shakeTimeline = gsap.timeline({onUpdate:() => {
                    const xOffset = shakeIntensity * (Math.random() * 2 - 1);
                    const yOffset = shakeIntensity * (Math.random() * 2 - 1);
                    this.basedCountUp.position.set(360 + xOffset, 200 + yOffset);
                }
            }).add(() => {}, '>3');
            const countUpSound =   timesBetWon > 250
                                 ? "countUpOutroLevel5"
                                 : timesBetWon > 100
                                 ? "countUpOutroLevel4"
                                 : timesBetWon > 50
                                 ? "countUpOutroLevel3"
                                 : timesBetWon > 25
                                 ? "countUpOutroLevel2"
                                 : "countUpOutroLevel1"
            tl.add(() => { BrickSnake2000.soundPlayer.playSound(countUpSound)}, '>0.3');
            tl.add(shakeTimeline, '<')
            tl.add(gsap.to(this.basedCountUp.scale, {x: growthSize, y: growthSize, duration:3 }), '<')
            tl.add(this.basedCountUp.countUpNoFade(totalWin, 0, 3), '<');
            tl.add(() => {
                BrickSnake2000.soundPlayer.playSound("fsOutroCountUpEnd");
                BrickSnake2000.soundPlayer.stopSound(countUpSound);
                this.basedCountUp.position.set(360, 200);
                this.basedCountUp.scale.set(1, 1);
            })
        }
        tl.add(() =>  {
            this.freespinsActualMultiplier.text = `x${timesBetWon}`;
            this.freespinsActualMultiplier.visible = true;
            if (winAboveBet) {
                BrickSnake2000.soundPlayer.playSound("fsOutroPresentation");
            }
        }, '>0.4')
        tl.add(() => {}, '>0.2');
        //tl.add(totalWin > 0 && winAboveBet
        //    ? () => { BrickSnake2000.soundPlayer.playSound("fsOutroCountUp"); }
        //    : () => {}, totalWin > 0 ? '>0.5' : '>' )
        //tl.add(totalWin > 0 && winAboveBet
        //    ? this.basedCountUp.countUpNoFade(totalWin, 0, 1.5)
        //    : () => {}, '<')
        //tl.add(totalWin > 0 && winAboveBet
        //    ? () => {
        //        BrickSnake2000.soundPlayer.playSound("fsOutroCountUpEnd");
        //        BrickSnake2000.soundPlayer.stopSound("fsOutroCountUp");
        //    }
        //    : () => {})
        return tl;
    }

    public hideOutroInformation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.freespinsTotalWin.visible = false;
                this.basedCountUp.hide();
                this.freespinsSpinsPlayed.visible = false;
                this.freespinsActualMultiplier.visible = false;
            });
    }
}